import { createFileRoute } from '@tanstack/react-router';
import { ContaDigitalTermoDeUso } from '@/features/conta-digital/page/termo-de-uso/ContaDigitalTermoDeUso';

export const Route = createFileRoute('/p/conta-digital/termos-de-uso/$base64')({
    component: Component,
});

function Component() {
    const { base64 } = Route.useParams();

    return <ContaDigitalTermoDeUso base64={base64} />;
}
